import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Badge component for displaying small informational tags
 * @param {string} label - Text to display in the badge
 * @param {string} className - Additional CSS classes
 * @param {string} variant - Badge style variant (default, primary, secondary)
 */
function Badge({ label, className, variant = 'primary' }) {
  return (
    <div className={clsx('badge', `badge--${variant}`, className)}>
      <span>{label}</span>
    </div>
  );
}

Badge.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'error']),
};

export default Badge;
